module.exports = __webpack_public_path__ + "static/media/meditronic.f218a48b.png";